import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { CircularProgress } from '@mui/material';

export function CustomButton({
    children,
    loading,
    width,
    height,
    disabled,
    type = 'button',
    ...props
}: any) {
    return (
        <Button disableRipple disabled={disabled} type={type} {...props}>
            {children}
            {loading && (
                <CircularProgress color='inherit' size={16} sx={{ ml: 1 }} />
            )}
        </Button>
    );
}
